import { lazyWithRetry } from '@/shared/lib/lazy-with-retry'

export const LoginPage = lazyWithRetry(() =>
  import('@/pages/login').then((m) => ({ default: m.LoginPage })),
)
export const ForgotPasswordPage = lazyWithRetry(() =>
  import('@/pages/forgot-password').then((m) => ({
    default: m.ForgotPasswordPage,
  })),
)
export const PlanPage = lazyWithRetry(() =>
  import('@/pages/plan').then((m) => ({ default: m.PlanPage })),
)
export const ProfilePage = lazyWithRetry(() =>
  import('@/pages/profile').then((m) => ({ default: m.ProfilePage })),
)
export const PhotoAlbumPage = lazyWithRetry(() =>
  import('@/pages/photo-album').then((m) => ({ default: m.PhotoAlbumPage })),
)
// MUST stay lazy: this page pulls the Compose wasm canvas and, through the replay overlay, the
// whole video.js player. Imported eagerly it lands in the entry chunk, so every user parses a video
// player on first paint — including those without the Collection arm, who cannot open the tab.
export const CollectionPage = lazyWithRetry(() =>
  import('@/pages/collection').then((m) => ({ default: m.CollectionPage })),
)
export const OnboardingPage = lazyWithRetry(() =>
  import('@/pages/onboarding').then((m) => ({ default: m.OnboardingPage })),
)
export const ReturnPage = lazyWithRetry(() =>
  import('@/pages/return').then((m) => ({ default: m.ReturnPage })),
)
export const DayPage = lazyWithRetry(() =>
  import('@/pages/day').then((m) => ({ default: m.DayPage })),
)
export const DayPracticePage = lazyWithRetry(() =>
  import('@/pages/day-practice').then((m) => ({ default: m.DayPracticePage })),
)
export const StepPracticePreviewPage = lazyWithRetry(() =>
  import('@/pages/step-practice-preview').then((m) => ({
    default: m.StepPracticePreviewPage,
  })),
)
export const FlowPracticePage = lazyWithRetry(() =>
  import('@/pages/flow-practice').then((m) => ({
    default: m.FlowPracticePage,
  })),
)
export const TodayPage = lazyWithRetry(() =>
  import('@/pages/today').then((m) => ({ default: m.TodayPage })),
)
export const LanguagePage = lazyWithRetry(() =>
  import('@/pages/language').then((m) => ({ default: m.LanguagePage })),
)
export const ChangePasswordPage = lazyWithRetry(() =>
  import('@/pages/change-password').then((m) => ({
    default: m.ChangePasswordPage,
  })),
)
export const SettingsPage = lazyWithRetry(() =>
  import('@/pages/settings').then((m) => ({ default: m.SettingsPage })),
)
export const AutoLoginPage = lazyWithRetry(() =>
  import('@/pages/auto-login').then((m) => ({ default: m.AutoLoginPage })),
)
export const MembershipInfoPage = lazyWithRetry(() =>
  import('@/pages/membership-info').then((m) => ({
    default: m.MembershipInfoPage,
  })),
)
// Public landing for the Non-Visa cancellation-confirmation email link.
export const EmailCancellationPage = lazyWithRetry(() =>
  import('@/pages/email-cancellation').then((m) => ({
    default: m.EmailCancellationPage,
  })),
)
export const PauseSubscriptionPage = lazyWithRetry(() =>
  import('@/pages/pause-subscription').then((m) => ({
    default: m.PauseSubscriptionPage,
  })),
)
export const UpdatePaymentMethodPage = lazyWithRetry(() =>
  import('@/pages/update-payment-method').then((m) => ({
    default: m.UpdatePaymentMethodPage,
  })),
)
export const RenewSubscriptionPage = lazyWithRetry(() =>
  import('@/pages/renew-subscription').then((m) => ({
    default: m.RenewSubscriptionPage,
  })),
)
export const CancelSubscriptionPage = lazyWithRetry(() =>
  import('@/pages/cancel-subscription').then((m) => ({
    default: m.CancelSubscriptionPage,
  })),
)
export const BillingHistoryPage = lazyWithRetry(() =>
  import('@/pages/billing-history').then((m) => ({
    default: m.BillingHistoryPage,
  })),
)
export const ContactSupportPage = lazyWithRetry(() =>
  import('@/pages/contact-support').then((m) => ({
    default: m.ContactSupportPage,
  })),
)
// Dev builds only: production replaces the flag with false and drops the chunk.
export const DevDeckPage = import.meta.env.DEV
  ? lazyWithRetry(() =>
      import('@/pages/dev-deck').then((m) => ({ default: m.DevDeckPage })),
    )
  : null
export const DevWheelPage = import.meta.env.DEV
  ? lazyWithRetry(() =>
      import('@/pages/dev-wheel').then((m) => ({ default: m.DevWheelPage })),
    )
  : null
